module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-validator', {
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('username-suggest', {
    ref: "uid",
    attrs: {
      "value": _vm.form_data.uid,
      "fname": _vm.fname,
      "lname": _vm.lname,
      "required": ""
    },
    on: {
      "input": _vm.updateUid,
      "form-state": function($event) {
        return _vm.updateUidValid($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('password-form', {
    attrs: {
      "suggestions-in-modal": true,
      "isNewPassword": false,
      "hide-password-notifications": true
    },
    on: {
      "input": _vm.updatePassword,
      "form-state": _vm.updatePasswordValid
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1714d61b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/UserForm.vue
// module id = 1309
// module chunks = 16